export default __webpack_public_path__ + "static/media/notifactions.f243c737.svg";